import sliceCreator from '../../index.jsx';
import {GET_BY_ID_CROP} from '../../../constants/index.jsx';
const _getByCropAction = sliceCreator('GET_BY_ID_CROP', GET_BY_ID_CROP, 'get');

const { asyncAction: getByCropAction, reducer, clearData: clearGetByCropAction } = _getByCropAction;

export default reducer;

export {
    getByCropAction,
    clearGetByCropAction
}